<template>
  <svg
    width="96"
    height="24"
    viewBox="0 0 96 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.8143 14.0038V19.0925H1.0918V3.82617H7.45278C11.3457 3.82617 13.623 5.48002 13.623 8.53329C13.623 11.5865 11.3457 13.2405 7.45278 13.2405H4.61578L3.8143 14.0038ZM7.45278 10.7342C9.76818 10.7342 10.8623 9.93271 10.8623 8.57146C10.8623 7.21022 9.7173 6.37056 7.45278 6.37056H3.8143V10.7215L7.45278 10.7342Z"
      fill="white"
    />
    <path
      d="M24.13 19.4622C19.8045 19.4622 17.0566 15.9381 17.0566 11.4855C17.0566 7.0328 19.8045 3.49609 24.13 3.49609C28.4554 3.49609 31.2034 7.02008 31.2034 11.4855C31.2034 15.9509 28.4554 19.4622 24.13 19.4622ZM24.13 6.05322C21.2675 6.05322 19.9063 8.49583 19.9063 11.4855C19.9063 14.4751 21.2675 16.905 24.13 16.905C26.9924 16.905 28.3538 14.4751 28.3538 11.4855C28.3538 8.49583 26.9924 6.05322 24.13 6.05322Z"
      fill="white"
    />
    <path
      d="M39.561 16.5481H47.3088V19.0925H36.0625V3.82617H38.7596V15.7848L39.561 16.5481Z"
      fill="white"
    />
    <path
      d="M55.7965 16.5481H63.4296V19.0925H52.2344V3.82617H54.9441V15.7848L55.7965 16.5481Z"
      fill="white"
    />
    <path
      d="M78.4893 3.82617H81.7207L71.1996 19.0925H67.9683L72.0011 13.2149V12.1464L66.3145 3.82617H69.5203L74.0113 10.3144L78.4893 3.82617Z"
      fill="white"
    />
    <path
      d="M93.1594 1.0918L95.4365 2.4276L81.3915 22.91H78.1855L93.1594 1.0918Z"
      fill="#01FFF0"
    />
  </svg>
</template>

<script>
export default {
  name: 'PollyWordmark',
};
</script>
